import { css } from '@emotion/core';
import { shadow, variables, aNormalize, media, tokens } from '@domain-group/fe-brary';
import { DEFAULT_LOGO_HEIGHT, TWENTY_FIVE_YEARS_LOGO_HEIGHT } from './allhomes-header.style';
var colors = tokens.colors,
  shadows = tokens.shadows;
var SMALL_MOBILE_MAX_WIDTH = '385px';
var LARGE_MOBILE_MIN_WIDTH = '386px';
export var header = /*#__PURE__*/css("background-color:", colors.neutral.surface.default, ";display:flex;height:60px;align-items:center;justify-content:space-between;flex-direction:row;padding:0 8px;");
export var hamburgerButton = {
  name: "65z1sb",
  styles: "padding:0;flex-shrink:0;"
};
export var leftSide = {
  name: "c37wcw",
  styles: "gap:6px;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;"
};
export var rightSide = /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:flex-end;align-items:center;gap:16px;", media('>=tablet'), "{padding-right:8px;}");
export var logo = variant => /*#__PURE__*/css(aNormalize, " display:flex;flex-shrink:0;height:", variant === '25-years' ? TWENTY_FIVE_YEARS_LOGO_HEIGHT : DEFAULT_LOGO_HEIGHT, ";@media (max-width:", SMALL_MOBILE_MAX_WIDTH, "){height:", DEFAULT_LOGO_HEIGHT, ";}");
export var modalLogo = variant => /*#__PURE__*/css(aNormalize, " display:flex;flex-shrink:0;height:", variant === '25-years' ? TWENTY_FIVE_YEARS_LOGO_HEIGHT : DEFAULT_LOGO_HEIGHT, ";", variant === '25-years' && /*#__PURE__*/css("@media (max-width:", SMALL_MOBILE_MAX_WIDTH, "){display:none;}"));
export var modalFallbackLogo = /*#__PURE__*/css(aNormalize, " display:flex;flex-shrink:0;height:", DEFAULT_LOGO_HEIGHT, ";@media (min-width:", LARGE_MOBILE_MIN_WIDTH, "){display:none;}");
export var logoImage = variant => /*#__PURE__*/css("height:100%;", variant === '25-years' && /*#__PURE__*/css("@media (max-width:", SMALL_MOBILE_MAX_WIDTH, "){display:none;}"));
export var fallbackLogoImage = /*#__PURE__*/css("height:", DEFAULT_LOGO_HEIGHT, ";@media (min-width:", LARGE_MOBILE_MIN_WIDTH, "){display:none;}");
export var navMenuMembership = {
  name: "1e8jwnz",
  styles: "display:flex;flex-direction:row;justify-content:space-between;gap:8px;padding:16px;"
};
export var membershipButton = {
  name: "1cv2bhb",
  styles: "position:relative;gap:16px;display:flex;"
};
export var membershipMenu = /*#__PURE__*/css("position:absolute;z-index:", variables.global.layerPopout, ";box-shadow:", shadow(shadows.elevation4), ";border-radius:3px;background-color:", colors.neutral.surface.default, ";width:auto;right:-32px;top:100%;");